module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-square-11bc12aa.svg";